import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import { FormModalButton, type EntityField } from '@/shared/ui/list/EntityFormModal';
import { ToggleCell } from '@/shared/ui/list/ToggleCell';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { addOrganization, changeOrganizationStatus } from './api';

const LIST_KEY = 'marketing-organization';

interface Organization extends ListRow {
  id: number;
  title?: string;
  name?: string;
  cashback?: number | string;
  status_id?: number;
}

const FIELDS: EntityField[] = [
  { name: 'title', label: 'Заголовок', placeholder: 'Заголовок...' },
  { name: 'name', label: 'Название', placeholder: 'Название...' },
  { name: 'cashback', label: 'Кэшбэк', type: 'number', placeholder: 'Кэшбэк...' },
];

const config: ListPageConfig<Organization> = {
  queryKey: LIST_KEY,
  title: 'Организации',
  errorText: 'Ошибка загрузки организаций',
  fetchList: postListFetcher('/customer/loyalty-organization/search/'),
  rows: ['organizations'],
  paginated: false,
  searchKeys: [
    { value: 'title', label: 'Поиск по заголовку' },
    { value: 'name', label: 'Поиск по названию' },
    { value: 'cashback', label: 'Поиск по кэшбэку' },
  ],
  headerActions: (
    <FormModalButton
      buttonLabel="Создать"
      buttonClassName="btn btn-info pull-right"
      title="Создать организацию"
      fields={FIELDS}
      initial={{ title: '', name: '', cashback: '' }}
      save={(v) =>
        addOrganization({ title: String(v.title), name: String(v.name), cashback: String(v.cashback) })
      }
      listKey={LIST_KEY}
    />
  ),
  columns: [
    { header: 'id', render: (org) => org.id },
    { header: 'Заголовок', render: (org) => org.title },
    { header: 'Название', render: (org) => org.name },
    { header: 'Кешбек', render: (org) => org.cashback },
    {
      header: 'Статус активности',
      render: (org) => (
        <ToggleCell
          checked={Boolean(Number(org.status_id))}
          listKey={LIST_KEY}
          toggle={(next) => changeOrganizationStatus(org.id, next)}
        />
      ),
    },
  ],
};

export const OrganizationPage = () => <GenericListPage config={config} />;
